<template>
    <div class="voucher-code-card card border position-fixed" :class="classes" style="bottom: 30px; right: 30px; z-index: 1;">
        <div class="card-body p-3 d-flex align-items-center">
            <div class="d-flex flex-column">
                <strong>
                    {{ code }}
                </strong>

                <!-- Purchases -->
                <div v-if="data && data.purchases">
                    <small class="d-block text-muted" v-for="purchase in data.purchases">
                        Kauf am {{ $moment(purchase.created_at).format('DD.MM.YYYY') }}
                        <a :href="'/backend/service/bookings/' + purchase.booking_id" target="_blank">
                            ({{ purchase.booking_id }})
                            <i class="far fa-external-link-square ml-1"></i>
                        </a>
                    </small>
                </div>
            </div>

            <i class="fa fa-spinner fa-spin ml-4" v-if="isLoading"></i>
            <div class="ml-4" v-if="! isLoading">
                <!-- Refresh -->
                <button type="button" class="btn btn-link" @click="load">
                    <i class="fa fa-sync"></i>
                </button>

                <!-- Detach code -->
                <a :href="$window.route('frontend.checkout.vouchers.codes.forget')" class="btn btn-link">
                    <i class="fa fa-trash"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['code'],
        data() {
            return {
                data: null,
                isLoading: false,
                classes: ['fadeInUp', 'animated'],
            }
        },
        mounted() {
            this.load()
        },
        computed: {},
        methods: {
            load() {
                var self = this;
				this.isLoading = true;
                this.data = null

				axios.get(route('api.checkout.vouchers.codes.show', {
                    code: this.code,
                })).then(function (response) {
					self.data = response.data.data;

					self.isLoading = false;
				}).catch(function (error) {
					console.log(error);
					self.isLoading = false;
				});
            },
        },
        watch: {}
    }
</script>
